import { useAuth } from '../contexts/AuthContext';

export type UserRole = 'admin' | 'support' | 'user';

export function useUserRole() {
  const { isAdmin, isSuperAdmin, isSupportUser } = useAuth();

  const role: UserRole = isSuperAdmin || isAdmin ? 'admin' : isSupportUser ? 'support' : 'user';

  const canDelete = isSuperAdmin || isAdmin;
  const canEdit = isSuperAdmin || isAdmin || isSupportUser;
  const canView = isSuperAdmin || isAdmin || isSupportUser;
  const canCreate = isSuperAdmin || isAdmin || isSupportUser;

  return {
    role,
    isAdmin: isSuperAdmin || isAdmin,
    isSuperAdmin,
    isSupportUser,
    canDelete,
    canEdit,
    canView,
    canCreate,
  };
}
